'use client';
import ProductDetailsQuick from "@/components/shared/modals/ProductDetailsQuick";
import { createContext, useContext, useState } from "react";
import {useUserContext} from '@/providers/UserContext';

const ProductContext = createContext(null);

export default function ProductContextProvider({ children }) {
  const [currentProduct, setCurrentProduct] = useState(null);
  const {user} = useUserContext();
  return (
    <ProductContext.Provider value={{ currentProduct, setCurrentProduct }}>
      {children}
      <ProductDetailsQuick product={currentProduct} clientType={user?.clientType}/>
      {/*<CartStatusModal product={currentProduct} />*/}
      {/*<WishlistStatusModal product={currentProduct} />*/}
    </ProductContext.Provider>
  );
};
export const useProductContext = () => {
  return useContext(ProductContext);
};
